document.addEventListener("DOMContentLoaded", function () {
  const toggleButton = document.getElementById("toggle-description");
  const expander = document.getElementById("expander");

  if (toggleButton) {
    toggleButton.onclick = () => {
      expander && expander.classList.toggle("is-opened");
    };
  }

  const toggleProductMedia = document.getElementById("expand-product-media");

  if (toggleProductMedia) {
    toggleProductMedia.onclick = () => {
      const productGallery = document.querySelector("product-gallery");
      productGallery && productGallery.classList.add("is-open");
      toggleProductMedia.remove();
    };
  }
});
